import { useState, useEffect } from "react";

import Select from 'react-select';

import { logout } from '../../auth';
import { useNavigate } from 'react-router-dom';
import { get, post } from '../../services/api';
import { parseObjectToURLQuery } from '../../utils'

export default function FiltrosHabilitarRegioes({
    filtros,
    setFiltros,
    setRegioes,
    setLoad
}) {
    //Options
    const [ optionsRegiao, setOptionsRegiao ] = useState([]);
    const [ optionsFilial, setOptionsFilial ] = useState([]);
    const [ optionsSituacao, setOptionsSituacao ] = useState([]);

    //Popular options
    async function setOptionsRegiaoWithRequest(authToken) {
        try {
            const regioes = await get(`/admin/metas/regiao?${parseObjectToURLQuery({
                habilitadas: 'false'
            })}`, null, authToken);

            const options = [
                { label: 'Todas', value: 0 },
                ... regioes.map(regiao => ({ 
                    label: regiao.nome_regiao, 
                    value: regiao.id_regiao 
                }))
            ];

            setOptionsRegiao(options);

            return regioes;
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }
    async function setOptionsFilialWithRequest() {
        try {
            const requisicao = { idRegiao: 0, habilitadas: false };
            const filiais = await post('/vendedores/filiais', requisicao);   

            const options = [
                { label: 'Todas', value: 0 },
                ... filiais.map(filial => ({
                    value: filial.cod_sabium,
                    label: filial.cod_sabium - 10000 + ' - ' + filial.nome,
                }))
            ];

            setOptionsFilial(options);

            return filiais;
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }
    async function setOptionsSituacaoWithRequest() {
        try {
            const options = [
                { label: 'Todas', value: '' },
                { label: 'Habilitada', value: 'true' },
                { label: 'Desabilitada', value: 'false' }
            ];

            setOptionsSituacao(options);

            return options;
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }
    useEffect(() => {
        const authToken = localStorage.getItem("adminToken")

        if(authToken == null) {
            logout();
            navigate("/login");
            return;
        }

        setAuthTokenState(authToken);

        setOptionsSituacaoWithRequest();

        Promise.all([
            setOptionsRegiaoWithRequest(authToken),
            setOptionsFilialWithRequest()
        ]).then(() => filtrarHandler(authToken));
    }, []);

    //Actions
    async function filtrarHandler(authToken = authTokenState) {
        try {
            setLoad(true);
            const regioes = await get(`/admin/parametrizacao/regioeshabilitadas?${parseObjectToURLQuery({
                id_regioes: filtros.id_regioes,
                isHabilitadas: filtros.isHabilitadas 
            })}`, null, authToken);

            setRegioes(regioes.dados);
            
            setLoad(false);
            return regioes;
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    //Utils
    const [ authTokenState, setAuthTokenState ] = useState(undefined);
    const navigate = useNavigate();
    const mensagemNenhumaOpcaoAlternativa = () => 'Nenhuma opção disponível';

    return <>
        <div className="flex gap-4 items-end flex-wrap">
            <div style={{width: '200px'}}>
                <label htmlFor="id_regioes" className="admin-label">Selecione a região</label>
                <Select
                    name="id_regioes"
                    className="react-select"
                    classNamePrefix="react-select"
                    value={optionsRegiao.find(opt => opt.value == filtros.id_regioes)}
                    onChange={(regiao) => { 
                        setFiltros((filtros) => ({
                            ... filtros,
                            id_filiais: 0,
                            id_regioes: regiao.value
                        }))
                    }}
                    options={optionsRegiao}
                    placeholder="Regiões"
                    required
                    isSearchable={false}
                    noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                />
            </div>
            <div style={{width: '280px'}}>
                <label htmlFor="id_filiais" className="admin-label">Buscar por filial</label>
                <Select
                    name="id_filiais"
                    className="react-select"
                    classNamePrefix="react-select"
                    value={optionsFilial.find(opt => opt.value == filtros.id_filiais)}
                    onChange={(filial) => { 
                        setFiltros((filtros) => ({
                            ... filtros,
                            id_filiais: filial.value,
                            id_regioes: 0
                        }))
                    }}
                    options={optionsFilial}
                    placeholder="Filiais"
                    required
                    isSearchable={false}
                    noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                />
            </div>
            <div style={{width: '160px'}}>
                <label htmlFor="is_habilitadas" className="admin-label">Situação</label>
                <Select
                    name="is_habilitadas"
                    className="react-select"
                    classNamePrefix="react-select"
                    value={optionsSituacao.find(opt => opt.value == filtros.isHabilitadas)}
                    onChange={(isHabilitadas) => { 
                        setFiltros((filtros) => ({
                            ... filtros,
                            isHabilitadas: isHabilitadas.value
                        }))
                    }}
                    options={optionsSituacao}
                    placeholder="Situação"
                    required
                    isSearchable={false}
                    noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                />
            </div>
            <button className="admin-accept-btn" onClick={() => filtrarHandler()}>Filtrar</button>
        </div>
    </>
}